import { render, staticRenderFns } from "./InterestPage.vue?vue&type=template&id=493019fd&scoped=true&"
import script from "./InterestPage.vue?vue&type=script&lang=js&"
export * from "./InterestPage.vue?vue&type=script&lang=js&"
import style0 from "./InterestPage.vue?vue&type=style&index=0&id=493019fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493019fd",
  null
  
)

export default component.exports